import * as Yup from 'yup';

const errorMsg = 'Must be greater than 0';


export const customCheckRequestModalSchema = Yup.object().shape({
    customerName: Yup.string().required(),
    customerAmountRefund: Yup.number().nullable().moreThan(0, errorMsg).typeError('The amount invalid').required('The amount is required'),
    productType: Yup.string().required(),
    sellerAmountRefund: Yup.number().nullable().moreThan(0, errorMsg).typeError('The amount invalid').required('The amount is required'),
    achRefNumber: Yup.string().required(),
    payeeName: Yup.string().required(),
    reason: Yup.string().required(),
    provider: Yup.string().required(),
    lenderCode: Yup.string().required(),
    amountRequested: Yup.number().nullable().moreThan(0, errorMsg).typeError('The amount invalid').required('The amount is required'),
    cancelledDate: Yup.string().required(),
    legacyDealId: Yup.string()
    .required('Related Deal Numeric Id is required')
    .matches(/^\d+$/, 'Related Deal Numeric Id must be a number')
    .test('not-zero', 'Related Deal Numeric Id can’t be 0', (value) => value !== '0'),
});

export const dealsQueueFormValidation = Yup.object().shape({
   payeeName: Yup.string().nullable().required(),
});
